import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";
import SwitchingFormErrorsAlertBar from "./components/Switch/SwitchingFormErrorsAlertBar";
import SwitchingBackgroundPattern from "./components/SwitchingBackgroundPattern";
import ContextProvider from "./context/ContextProvider";
import Address from "./pages/Address";
import EnergyUsage from "./pages/EnergyUsage";
import Faqs from "./pages/Faqs";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Quotes from "./pages/Quotes";
import Switch from "./pages/Switch";
import SwitchStatus from "./pages/SwitchStatus";

function App() {

  return (
    <div className="bg-[#0c1f28] min-h-screen text-[#0c1f28] flex flex-col">
      <SwitchingBackgroundPattern />
      <div className="relative flex-1 mb-6">
        <Router>
          <ContextProvider>
            <SwitchingFormErrorsAlertBar />
            <Navbar />
            <div className="py-4">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/address" element={<Address />} />
                <Route
                  path="/energy-usage/:mpan/:mprn?"
                  element={<EnergyUsage />}
                />
                <Route path="/quotes/:mpan?/:mprn?" element={<Quotes />} />
                <Route
                  path="/switch/:priceId?/:mpan?/:mprn?"
                  element={<Switch />}
                />
                <Route
                  path="/switch-status/:switchId"
                  element={<SwitchStatus />}
                />
                <Route path="/faqs" element={<Faqs />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
            <ScrollToTop />
          </ContextProvider>
        </Router>
      </div>
      <Footer />
    </div>
  );
}

export default App;
